import { createEvent } from 'effector';
import { Attachment, EditorInstance } from '@nx-frontend/shared/types';
import { $imageViewer, initialImageViewerState } from './image-viewer';

const isImageExt = (filename: string) => {
  return /\.(jpe?g|png|gif|bmp|webp)$/i.test(filename);
};

export const showImageViewerForPageEvent = createEvent<{
  attachmentGlobalId: string;
  editorInstance: EditorInstance | null;
}>();

$imageViewer.on(showImageViewerForPageEvent, (_, payload) => {
  const { attachmentGlobalId, editorInstance } = payload;
  const mimeToExclude = ['image/tiff'];
  const attachmentGlobalIds =
    editorInstance?.plugins.imageManager
      ?.getAllImageAttachmnets()
      .filter(({ mime }) => !mimeToExclude.includes(mime))
      .map((item) => item.globalId ?? item.global_id) ?? [];

  const attachmentManager = editorInstance?.plugins?.attachmentManager;
  const attachments =
    attachmentManager?.options.attachments.filter(
      ({ mime, displayName }) => mime.startsWith('image/') || isImageExt(displayName)
    ) ?? [];

  const attachmentHash: Record<string, Attachment> = {};
  attachments.forEach((attachment) => {
    attachmentHash[attachment.globalId ?? attachment.global_id] = attachment;
  });

  if (attachmentGlobalIds.length && attachmentManager) {
    const slides = attachmentGlobalIds.map((globalId) => {
      // in case unsplash image
      if (globalId.match(/^psimg:/)) {
        return { src: globalId.replace(/^psimg:/, '') };
      } else {
        const attachment = attachmentHash[globalId];
        return { src: attachmentManager.options.getAttachmentLink(globalId, attachment.displayName) };
      }
    });

    return {
      open: true,
      index: attachmentGlobalIds.findIndex((globalId) => globalId === attachmentGlobalId) ?? 0,
      slides,
    };
  }
  return initialImageViewerState;
});
